export enum ActionState {
    DISABLED,
    ENABLED
}
